<template>
  <div class="pc">
    <img src="./index_01.jpg" class="pc pc-img" />
    <img src="./index_02.jpg" class="pc pc-img" />
    <img src="./index_03.jpg" class="pc pc-img" />
    <img src="./index_04.jpg" class="pc pc-img" />
    <img src="./index_05.jpg" class="pc pc-img" />
    <div class="pc footer">
      <span>蚂蚁游网络技术（北京）有限公司</span>
      <span>京ICP备2021037652号-1</span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
};
</script>
<style lang="less" scoped>
.pc {
  margin: 0 auto;
  .pc-img {
    display: block;
    width: 100%;
    height: auto;
  }
  &.footer {
    text-align: center;
    line-height: 40px;
    margin-top: 30px;
  }
  span {
    color: #bbb;
  }
  span + span {
    margin-left: 30px;
  }
}
</style>
